import { ISignInState } from '../states'
import { SignInActionTypes, SignInTypeKeys } from '../types'

const initialState: ISignInState = {
  username: {
    value: '',
    isValid: true
  },
  password: {
    value: '',
    isValid: true
  },
  error: null
}

export default (state: ISignInState = initialState, action: SignInActionTypes): ISignInState => {
  switch (action.type) {
    case SignInTypeKeys.SET_SIGN_IN_USERNAME_FIELD:
      return { ...state, username: action.payload }
    case SignInTypeKeys.SET_SIGN_IN_PASSWORD_FIELD:
      return { ...state, password: action.payload }
    case SignInTypeKeys.SET_SIGN_IN_ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}
